import md5 from 'md5';

export * from './gym';
export * from './skillSet';

export interface UpdateRequest {
  hash: string;
  playerId: number;
  salt: string;
  [key: string]: unknown;
}

/**
 * Populates the `salt` and `hash` fields of an update request using an HMAC-style
 * MD5 checksum. The hash is computed over all non-salt, non-hash property values
 * (sorted by key, lowercased) prepended by the salt.
 *
 * @param request - The request object to mutate in place.
 * @param salt - The salt value (provided by the caller from `window.salter()` or equivalent).
 */
export function hashUpdateRequest(request: UpdateRequest, salt: string): void {
  request.salt = salt;

  const excluded = new Set<string>(['salt', 'hash']);

  const hashSource =
    salt +
    Object.keys(request)
      .filter((key) => !excluded.has(key))
      .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
      .map((key) => request[key])
      .filter((val) => val !== null && val !== undefined)
      .map((val) => String(val as string | number | boolean).toLowerCase())
      .join('');

  request.hash = md5(hashSource);
}

export function currentFimYear({
  now,
  isIndia,
}: {
  now: Date;
  isIndia?: boolean;
}): string {
  //the current year
  const year = currentFimYearNumber({ now, isIndia });

  //format and return
  return `${year}/${year + 1}`;
}

export function previousFimYear({
  now,
  isIndia,
}: {
  now: Date;
  isIndia?: boolean;
}): string {
  //the previous year
  const year = currentFimYearNumber({ now, isIndia }) - 1;

  //format and return
  return `${year}/${year + 1}`;
}

function currentFimYearNumber({
  now,
  isIndia,
}: {
  now: Date;
  isIndia?: boolean;
}): number {
  //the year is this
  const year = now.getFullYear();

  //js months start at zero, so:
  const month = now.getMonth() + 1;

  //when does the year roll over; june in india, august in the US
  // eslint-disable-next-line no-magic-numbers
  const rollover = isIndia ? 6 : 8;

  //if current month >= rollover month, the fim year number is this one, otherwise the previous one
  //this is the difference between 2024/2025 and 2023/2024
  return month >= rollover ? year : year - 1;
}
